/* @generated */

// src/assets/pictogram/checkmark-circle.tsx
import * as React from "react";
var CheckmarkCirclePictogram = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.772 16.772C13.82 19.725 12 24.512 12 32c0 7.487 1.82 12.276 4.772 15.228C19.725 50.18 24.512 52 32 52c7.487 0 12.276-1.82 15.228-4.772C50.18 44.275 52 39.488 52 32c0-7.487-1.82-12.276-4.772-15.228C44.275 13.82 39.488 12 32 12c-7.487 0-12.276 1.82-15.228 4.772ZM8 32C8 15.85 15.85 8 32 8s24 7.85 24 24-7.85 24-24 24S8 48.15 8 32Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M43.828 26.828 41 24 29.414 35.585 23.828 30 21 32.828l8.414 8.415 14.414-14.415Z",
    fill: "currentColor"
  }
));
export {
  CheckmarkCirclePictogram
};
